<app-information-note
  message="The users you create here will have access to the Air Waybill generation and Manifest upload pages. You can easily share their login credentials from this section."></app-information-note>

<div class="table-tabs-container">
  <div class="table-tabs-header">
    <div class="table-tabs-title ibc-heading-h7-bold-subtitle">
      <span class="table-tab-name">{{ headerTextMap.AccountUsers }}</span>
    </div>
    <div class="tab-icons">
      <app-svg-icon
        [list]="headerIcons"
        class="icon-section"
        (iconClicked)="iconClickHandlerMap[$event.name]()"></app-svg-icon>
    </div>
  </div>
</div>

<app-add-inline-edit-table
  #inlineTable
  [inlineCrudTableCustomizeConfig]="accountUsersTableColumnConfig"
  [formConfig]="accountUserServiceFormConfig"
  [pageMode]="pageMode"
  [isFrom]="tableName.AccountUsers"
  (inlineTableSelectionChange)="updateTableIcons()">
</app-add-inline-edit-table>
